import { useTranslation } from 'react-i18next';

import { Switch, useToast } from '@bonusly/design-system';

import { useReduceBizyMotionPreference } from '../bizy';
import { PreferenceSettingRow } from './preference-setting-row';

export const MotionSection = () => {
	const { t } = useTranslation('bizy_settings', { keyPrefix: 'motion' });
	const { t: tSettings } = useTranslation('bizy_settings');
	const toast = useToast();
	const [reduceBizyMotion, setReduceBizyMotion] = useReduceBizyMotionPreference();

	const handleChange = (nextValue: boolean) => {
		if (nextValue === reduceBizyMotion) return;

		setReduceBizyMotion(nextValue);
		toast({ title: tSettings('saveBar.saved'), status: 'success', duration: 2500 });
	};

	return (
		<PreferenceSettingRow label={t('reduceMotionLabel')} tooltip={t('reduceMotionDescription')}>
			<Switch aria-label={t('reduceMotionAriaLabel')} flexShrink={0} isChecked={reduceBizyMotion} onChange={(event) => handleChange(event.target.checked)} />
		</PreferenceSettingRow>
	);
};
